import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { store } from "..";
import { Scout } from "../organisation/model/scout";
import { FastTrackScout } from "../organisation/model/fastTrack";
import { addPopupAction, setFastTrackScoutsAction } from "../organisation/organisationReducer";
import { getFastTrackScouts } from "../services/fastTrackService";
import { Status } from "../status/status";


/**
 * Refreshes the fast-track enrolments whenever the global document changes. GET /backoffice/fast-track/scouts
 * answers for the organisation in the JWT, so pass the organisation user's JWT, not the admin's.
 */
export const listenForGlobal = (organisationUserJwt: string) => {
    return firebase
      .firestore()
      .collection("env")
      .doc("prod")
      .collection("app")
      .doc("global")
      .onSnapshot((snapshot) => {
        getFastTrackScouts(organisationUserJwt, (scouts) => {


          const oldFastTrack = store.getState().organisation.fastTrackScouts;
          store.dispatch(setFastTrackScoutsAction(scouts));
          const fastTrackIds = scouts.map((f: FastTrackScout) => f.deviceId);
          const scoutsInFastTrack = Object.values(store
          .getState()
          .organisation.scouts).filter(
            (s: Scout) => fastTrackIds.indexOf(s.status.deviceId) > -1
            );
          store.dispatch(
            addPopupAction({
              id: "fast_track_devices",
              message: scoutsInFastTrack.length
                ? `${scoutsInFastTrack
                    .map((s: Scout) => s.status.displayName!)
                    .join(", ")} used in fast track`
                : "No devices in fast track",
              component: "Fast track",
              status: scoutsInFastTrack.length ? Status.Warning : Status.Ok,
              useInPopup: scoutsInFastTrack.length || oldFastTrack.length ? true  : false,
            })
          );

        });
      });
};
